// extracted by mini-css-extract-plugin
module.exports = {"item-container":"_3UDv5","itemContainer":"_3UDv5","description":"_3NVnw"};